module.exports = "/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved\n *\n * Licensed under CLOUD LINUX LICENSE AGREEMENT\n * http://cloudlinux.com/docs/LICENSE.TXT\n */\n.filter-panel {\n  text-align: right;\n}\n.accordion-wrapper {\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12);\n  margin: 25px 0;\n}\n.accordion-wrapper .blue_string {\n  color: #3A80CD;\n}\n.bottom-panel {\n  text-align: right;\n  margin-bottom: 25px;\n}\n.numeric-size /deep/ ui-text {\n  width: 48px;\n}\n.text-size /deep/ ui-text {\n  width: 220px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/styles/options.component.less
// module id = 1193
// module chunks = 1